var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-var */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

/**
 * This is a video widget for embedding videos in articles.
 */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var FixedToResponsive = require("../components/fixed-to-responsive.jsx");

// Current default is 720p, based on the typical videos we upload currently
var DEFAULT_WIDTH = 1280;
var DEFAULT_HEIGHT = 720;

var KA_EMBED = "https://{hostname}/embed_video?slug={slug}" + "&internal_video_only=1";
var IS_URL = /^https?:\/\//;
var IS_KA_SITE = /khanacademy\.org/;

/**
 * Video renderer.
 */
var Video = React.createClass({
    displayName: "Video",

    propTypes: _extends({}, Changeable.propTypes, {
        alignment: React.PropTypes.string,
        location: React.PropTypes.string
    }),

    getUserInput: function getUserInput() {
        return null;
    },

    simpleValidate: function simpleValidate(rubric) {
        return Video.validate(null, rubric);
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        var location = this.props.location;
        if (!location) {
            return React.createElement("div", null);
        }

        var url;

        if (IS_URL.test(location)) {
            url = location;
        } else {
            url = KA_EMBED.replace("{slug}", location);
            var currentHostname = document.location.hostname;
            var embedHostname = "www.khanacademy.org";
            if (IS_KA_SITE.test(currentHostname)) {
                embedHostname = currentHostname;
            }
            url = url.replace("{hostname}", embedHostname);
        }

        return React.createElement(
            FixedToResponsive // @Nolint this is fine, the linter is wrong
            ,
            { width: DEFAULT_WIDTH,
                height: DEFAULT_HEIGHT
                // The key is here for the benefit of the editor, to ensure that
                // any changes cause a re-rendering of the frame.
                , key: location + this.props.alignment
            },
            React.createElement("iframe", {
                className: "perseus-video-widget",
                sandbox: "allow-same-origin allow-scripts",
                width: DEFAULT_WIDTH,
                height: DEFAULT_HEIGHT,
                src: url,
                allowFullScreen: true
            })
        );
    }
});

/**
 * This is the widget's grading function.
 * Points for videos are tallied by the embedded video itself, in the case
 * of Khan Academy videos.
 */
_.extend(Video, {
    validate: function validate(state, rubric) {
        return {
            type: "points",
            earned: 0,
            total: 0,
            message: null
        };
    }
});

module.exports = {
    name: "video",
    displayName: "Video",
    defaultAlignment: "block",
    supportedAlignments: ["block", "float-left", "float-right", "full-width"],
    widget: Video
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/video.jsx
 ** module id = 156
 ** module chunks = 0 1
 **/